export const PREFIX = "debug";
export const showDebugLabelsPath =
	"store.solitairetripeaks.com:showDebugLabels";
export const showClockPath = "store.solitairetripeaks.com:showClock";
